import React, { Component } from 'react';
import FormResults from './components/FormResults';
import 'sweetalert/dist/sweetalert.css';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import WaitingModal from '../generics/WaitingModal';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import 'sweetalert/dist/sweetalert.css';

var Config = require('../../config');

const style = {
  margin: 7,
};

class ResultsNew extends Component{
	constructor(props) {
	    super(props);
	    this.saveItem = this.saveItem.bind(this);
	    this.cancel = this.cancel.bind(this);
	    this.getData = this.getData.bind(this);
	    
	    this.state = {
	    	validation:"",
	    	disable_save:false
	    };
	}

	componentWillMount() {
  	}

	cancel(e){
		this.props.history.push("/results_donation");
	}

	//Funcion Submit Form
	saveItem(e, validate){
		e.preventDefault();
		if (this.state.disable_save) {
	        return;
	    }
		this.setState({disable_save:true});
    		var items = this.form.getResults();
    		
		if(items.length > 0){
			this.props.waiting.handleShow('Guardando...');
    		
	      	fetch(Config.default.apiGateway.URL+'sample_results?donation_id='+this.props.match.params.donation_id, {
			  method: 'POST', // or 'PUT'
			  body: JSON.stringify(items), // data can be `string` or {object}!
			  headers: new Headers({
			  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
			  	'Accept': 'application/json',
			  	'Content-Type': 'application/json;charset=UTF-8'
			  })
			})
			.then(res => {
		      this.props.waiting.handleClose();
		      if(res.ok){
		        return res.json();
		      }else{
		        res.text().then(function(result) {
		          swal('¡Error!', result, 'error');
		        });
		      }})
			.then(response => {
				this.setState({disable_save:false});
		    	if(response !== undefined){
					notify.show('Registro Guardado','success');		

		    		this.props.history.push({
						pathname: "/results_donation/edit/"+response.id+"/"+this.props.match.params.donation_id+'/'+this.props.match.params.group_test_id,
						state:{
							validate: validate
						}
					});
		    	}else{
		    		notify.show('Error, No se pudo guardar','error');
		    	}
			});
		}else{
			notify.show('Error, No ha registrado ningún resultado.','error');
		}
	}

	getData(){
  		fetch(Config.default.apiGateway.URL+'samples/'+this.props.match.params.sample_id, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Typet'	: 'application/json'
			})

		})
		.then(res => {
			return res.json()
		})
		.then(response => {
			this.setState({
				sample: response.sample,
				results: response.results,
				validation: response.validation
			});
		});
  	}

	//Contenido de la pantalla para el alta de un nuevo registro
	render(){
		return(
			<div className="col-xs-12" style={{paddingTop:"10px"}}>
				<h2 style={{textAlign:"center"}}>
					Resultado de la Donación
				</h2>
		        <form noValidate>
		        	<FormResults {...this.props} state={this.state} onRef={ref => (this.form = ref)} 
						getData={this.getData} 
						saveItem={this.saveItem}
		        		waiting_modal = {this.waiting_modal}/>
		        	<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
		        	<Notifications />
		        </form>
		        <div className="col-xs-12" style={{textAlign:'center'}}>
	        		<RaisedButton className="action-btn" label="GRABAR" primary={true} 
	        			onClick={this.saveItem} style={style} disabled={this.state.disable_save}/>
	        		<RaisedButton className="action-btn" label="REGRESAR" primary={true} onClick={this.cancel} style={style}/>
		        </div>
		    </div>
		);
	}
}

export default translate('translations')(ResultsNew)